
export const fileUrl = "https://xhstools.oss-cn-beijing.aliyuncs.com/";
// export const fileUrl = "http://129.226.193.232:8086/api/upload/";



